<div
  class="bg-primary-gradient d-flex flex-column  {{ isInModal() ? 'flex-fill pt-6' : 'min-vh-100' }} container-fluid"
>
  <div class="flex-grow-1 row align-items-center">
    <div class="col-10 mx-auto" [ngClass]="{ 'col-sm-6 col-md-6 col-lg-4': !isInModal() }">
      <img
        class="mb-lg-5 d-block w-100 responsive-height hide-keyboard-open"
        width="282"
        height="131"
        src="/assets/images/iko-logo.svg"
        alt="iko logo"
      />

      <form
        id="registrationForm"
        class="form-signin rounded-2 p-4 pb-0"
        [formGroup]="registerForm"
        (ngSubmit)="register()"
        *ngIf="registerForm"
      >
        <div
          class="input-group"
          [ngClass]="{ 'has-danger': registerForm.get('mail')?.invalid && registerForm.get('mail')?.touched }"
        >
          <span class="input-group-text border-0 bg-light-transparent-4 text-white">
            <i class="icon icon-envelope-open"></i>
          </span>
          <input
            type="email"
            id="input-email"
            autocapitalize="none"
            class="placeholder-white form-control bg-light-transparent-4 border-0"
            [ngClass]="{
              'form-control-danger': registerForm.get('mail')?.invalid && registerForm.get('mail')?.touched
            }"
            [placeholder]="'Email' | translate"
            formControlName="mail"
            autocomplete="email"
          />
        </div>
        <div
          class="invalid-feedback-dark-background"
          *ngIf="registerForm.get('mail')?.hasError('required') && registerForm.get('mail')?.touched"
        >
          {{ 'ERRORS.EMPTY_FIELD' | translate }}
        </div>
        <div
          class="invalid-feedback-dark-background"
          *ngIf="registerForm.get('mail')?.hasError('email') && registerForm.get('mail')?.touched"
        >
          {{ 'ERRORS.WRONG_EMAIL_FORMAT' | translate }}
        </div>

        <div
          class="input-group"
          [ngClass]="{
            'has-danger': registerForm.get('first_name')?.invalid && registerForm.get('first_name')?.touched
          }"
        >
          <span class="input-group-text border-0 bg-light-transparent-4 text-white">
            <i class="icon icon-user-circle"></i>
          </span>
          <input
            type="text"
            id="input-fname"
            class="placeholder-white form-control bg-light-transparent-4 border-0"
            [ngClass]="{
              'form-control-danger': registerForm.get('first_name')?.invalid && registerForm.get('first_name')?.touched
            }"
            [placeholder]="'First Name' | translate"
            formControlName="first_name"
            autocomplete="given-name"
          />
        </div>
        <div
          class="invalid-feedback-dark-background"
          *ngIf="registerForm.get('first_name')?.hasError('required') && registerForm.get('first_name')?.touched"
        >
          {{ 'ERRORS.EMPTY_FIELD' | translate }}
        </div>
        @if(toolsService.fieldHasError(registerForm, 'first_name', 'blackList'); as wordsBlakListed){
        <div class="invalid-feedback-dark-background">
          {{ 'ERRORS.BLACKLIST_WORDS' | translate : { words: wordsBlakListed } }}
        </div>
        } @if(toolsService.fieldHasError(registerForm, 'first_name', 'link');){
        <div class="invalid-feedback-dark-background">
          {{ 'ERRORS.LINK' | translate }}
        </div>
        } @if(toolsService.fieldHasError(registerForm, 'first_name', 'onlyAlphabets')){
        <div class="invalid-feedback-dark-background">
          {{ 'ERRORS.ONLY_ALPHABETIC' | translate }}
        </div>
        } @if(toolsService.fieldHasError(registerForm, 'first_name', 'maxWords'); as maxWords){
        <div class="invalid-feedback-dark-background">
          {{ 'ERRORS.MAX_WORDS' | translate : { count: maxWords } }}
        </div>
        }

        <div
          class="input-group"
          [ngClass]="{ 'has-danger': registerForm.get('last_name')?.invalid && registerForm.get('last_name')?.touched }"
        >
          <span class="input-group-text border-0 bg-light-transparent-4 text-white">
            <i class="icon icon-user-circle"></i>
          </span>
          <input
            type="text"
            id="input-lname"
            class="placeholder-white form-control bg-light-transparent-4 border-0"
            [ngClass]="{
              'form-control-danger': registerForm.get('last_name')?.invalid && registerForm.get('last_name')?.touched
            }"
            [placeholder]="'Last Name' | translate"
            formControlName="last_name"
            autocomplete="family-name"
          />
        </div>
        <div
          class="invalid-feedback-dark-background"
          *ngIf="registerForm.get('last_name')?.hasError('required') && registerForm.get('last_name')?.touched"
        >
          {{ 'ERRORS.EMPTY_FIELD' | translate }}
        </div>
        @if(toolsService.fieldHasError(registerForm, 'last_name', 'blackList'); as wordsBlakListed){
        <div class="invalid-feedback-dark-background">
          {{ 'ERRORS.BLACKLIST_WORDS' | translate : { words: wordsBlakListed } }}
        </div>
        } @if(toolsService.fieldHasError(registerForm, 'last_name', 'link');){
        <div class="invalid-feedback-dark-background">
          {{ 'ERRORS.LINK' | translate }}
        </div>
        } @if(toolsService.fieldHasError(registerForm, 'last_name', 'onlyAlphabets')){
        <div class="invalid-feedback-dark-background">
          {{ 'ERRORS.ONLY_ALPHABETIC' | translate }}
        </div>
        } @if(toolsService.fieldHasError(registerForm, 'last_name', 'maxWords'); as maxWords){
        <div class="invalid-feedback-dark-background">
          {{ 'ERRORS.MAX_WORDS' | translate : { count: maxWords } }}
        </div>
        }

        <app-captcha></app-captcha>
        <!-- <app-loader *ngIf="loading" class="small text-white"></app-loader> -->

        <button class="px-3 btn btn-lg btn-success btn-block btn-round" type="submit" translate>Register</button>

        <div class="small text-white text-center my-3">
          <span translate>By proceeding, you agree to the</span>
          <a class="text-success" [routerLink]="'/terms-of-use' | localize" translate> Terms of Use </a>
          <span translate> and </span>
          <a class="text-success" [routerLink]="'/privacy-policy' | localize" translate> Privacy Policy </a>
        </div>
      </form>
      <div class="p-4 pt-0">
        <button
          *ngIf="displayFacebook"
          class="px-3 btn btn-lg btn-primary btn-block btn-round"
          (click)="registerFacebook()"
        >
          <img src="/assets/images/icon-facebook.svg" height="20" alt="facebook-logo" />
          {{ 'Register with Facebook' | translate }}
        </button>
        <button
          *ngIf="displayApple"
          id="btn-login-apple"
          type="button"
          class="px-3 btn btn-lg btn-primary btn-block btn-round"
          (click)="loginApple()"
        >
          <img src="/assets/images/apple-logo.png" alt="apple-logo" />
          <span translate> Sign in with Apple </span>
        </button>
        @if(displayGoogle()) {
        <button
          id="google-login"
          class="px-3 btn btn-lg btn-light btn-block btn-round d-flex align-items-center justify-content-center"
          (click)="handleClickGoogleLogin($event)"
        >
          <img src="https://developers.google.com/identity/images/g-logo.png" alt="Google Logo" class="me-1" />
          <span translate>Sign up with Google</span>
        </button>
        }
      </div>
      <div class="row small lr-0 py-3 bottom-0 font-size-16 hide-keyboard-open">
        <div class="col-6">
          @if(!isInModal()) {
          <a
            [routerLink]="'/user/login' | localize"
            class="text-white text-decoration-underline"
            [queryParams]="redirectParamForTemplate()"
            translate
            >Login</a
          >
          }@else {
          <a class="text-white text-decoration-underline" (click)="requestLogin.emit()" translate>Login</a>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="row small lr-0 px-3 py-2 position-fixed bottom-0 show-keyboard-open bg-light-transparent-2">
    <div class="col-6" [routerLink]="'/user/login' | localize">
      <button class="nav-link text-white text-decoration-underline" translate>Login</button>
    </div>
  </div>
  <div class="position-fixed small bottom-0 row text-success w-100 d-flex align-items-center mb-4">
    <div class="col-6 text-right pe-3">
      <a class="text-success" [routerLink]="'/privacy-policy' | localize" translate> Privacy Policy </a>
    </div>
    <div class="col-6 ps-3">
      <a class="text-success" [routerLink]="'/terms-of-use' | localize" translate> Terms of use </a>
    </div>
  </div>
</div>
